import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector
} from 'react-redux';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { ENABLE_REDUX_DEV_TOOLS } from 'src/constants';
import rootReducer from './rootReducer';
import { basename } from 'src/config';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: []
};

export const history = createBrowserHistory({ basename: basename });

const persistedReducer = persistReducer(persistConfig, rootReducer(history));

// redux-persistを導入した関係での対応
// これをやらないと下記のエラーが発生する
// index.js:1 A non-serializable value was detected in an action, in the path: `register`. persist
// 参考: https://github.com/rt2zz/redux-persist/issues/988
// 参考: https://stackoverflow.com/questions/61704805/getting-an-error-a-non-serializable-value-was-detected-in-the-state-when-using
const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: { ignoredActions: ['persist/PERSIST'] }
});

const store = configureStore({
  reducer: persistedReducer,
  devTools: ENABLE_REDUX_DEV_TOOLS,
  middleware: [routerMiddleware(history), ...customizedMiddleware]
});

export const useSelector = useReduxSelector;

export const useDispatch = () => useReduxDispatch();

export default store;
